import React 		from 'react';
import ReactDOM from 'react-dom';
import Highlight 		from 'react-highlight';

import BLComponent from '../core/_BLComponent.jsx';

export default class ResourceRepOrder extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			
		};
	}

	render() {
		return (
			<section>
				<h1 className="text--xxl-title l-margin-bottom--xl">Order: Resource Representations</h1>
				<h2 className="text--title l-margin-bottom">Order</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> order_id </td>
							<td> String </td>
							<td> Unique identifier for this order for internal use </td>
							<td> </td>
						</tr>
						<tr>
							<td> date_ordered </td>
							<td> Timestamp </td>
							<td> The time the order was created </td>
							<td> </td>
						</tr>
						<tr>
							<td> date_status_changed </td>
							<td> Timestamp </td>
							<td> The time the order status was last modified </td>
							<td> </td>
						</tr>
						<tr>
							<td> seller_name </td>
							<td> String </td>
							<td> The username of the seller in BL </td>
							<td> </td>
						</tr>
						<tr>
							<td> store_name </td>
							<td> String </td>
							<td> The store name displayed on BL store pages </td>
							<td> </td>
						</tr>
						<tr>
							<td> buyer_name </td>
							<td> String </td>
							<td> The username of the buyer in BL </td>
							<td> </td>
						</tr>
						<tr>
							<td> buyer_email </td>
							<td> String </td>
							<td> E-mail address of the buyer</td>
							<td> </td>
						</tr>
						<tr>
							<td> buyer_order_count </td>
							<td> Integer </td>
							<td> Total count of all orders placed by the buyer in the seller's store. Includes the order just placed and also purged orders </td>
							<td> </td>
						</tr>
						<tr>
							<td> require_insurance </td>
							<td> Boolean </td>
							<td> Indicates whether the buyer requests insurance for this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> status </td>
							<td> String </td>
							<td> The status of an order</td>
							<td><a href="http://www.bricklink.com/help.asp?helpID=41&amp;q=order+status" target="_blank">Available status</a> </td>
						</tr>
						<tr>
							<td> is_invoiced </td>
							<td> Boolean </td>
							<td> Indicates whether the order invoiced </td>
							<td> </td>
						</tr>
						<tr>
							<td> is_filed </td>
							<td> Boolean </td>
							<td> Indicates whether the order is filed </td>
							<td>  </td>
						</tr>
						<tr>
							<td> drive_thru_sent </td>
							<td> Boolean </td>
							<td> Indicates whether "Thank You, Drive Thru!" email has been sent </td>
							<td> </td>
						</tr>
						<tr>
							<td> salesTax_collected_by_bl </td>
							<td> Boolean </td>
							<td> Indicates if sales tax are collected by BL or not </td>
							<td> </td>
						</tr>
						<tr>
							<td> remarks </td>
							<td> String </td>
							<td> User remarks for this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> total_count </td>
							<td> Integer </td>
							<td> The total number of items included in this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> unique_count </td>
							<td> Integer </td>
							<td> The unique number of items included in this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> total_weight </td>
							<td> Fixed Point Number</td>
							<td> The total weight of the items ordered<br/>- It applies the seller's custom weight when present to override the catalog weight<br/>- 0 if the order includes at least one item without any weight information or incomplete set </td>
							<td> </td>
						</tr>
						<tr>
							<td> payment </td>
							<td> Object </td>
							<td> Information related to the payment of this order  </td>
							<td> </td>
						</tr>
						<tr>
							<td> payment.method</td>
							<td> String </td>
							<td> The payment method for this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> payment.currency_code </td>
							<td> String </td>
							<td> Currency code of the payment </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a></td>
						</tr>
						<tr>
							<td> payment.date_paid </td>
							<td> Timestamp </td>
							<td> The time the buyer paid </td>
							<td> </td>
						</tr>
						<tr>
							<td> payment.status </td>
							<td> String </td>
							<td> Payment status </td>
							<td> <a href="http://www.bricklink.com/help.asp?helpID=121" target="_blank">Available status</a> </td>
						</tr>
						<tr>
							<td> shipping </td>
							<td> Object </td>
							<td> Information related to the shipping </td>
							<td> </td>
						</tr>
						<tr>
							<td> shipping.method </td>
							<td> String </td>
							<td> Shipping method name </td>
							<td> </td>
						</tr>
						<tr>
							<td> shipping.method_id </td>
							<td> String </td>
							<td> Shipping method ID </td>
							<td>  </td>
						</tr>
						<tr>
							<td> shipping.tracking_no </td>
							<td> String </td>
							<td> Tracking numbers for the shipping </td>
							<td> </td>
						</tr>
						<tr>
							<td> shipping.tracking_link </td>
							<td> String </td>
							<td> URL for tracking the shipping </td>
							<td> API-only field. It is not shown on the BrickLink pages. </td>
						</tr>
						<tr>
							<td> shipping.date_shipped </td>
							<td> Timestamp </td>
							<td> Shipping date </td>
							<td> API-only field. It is not shown on the BrickLink pages. </td>
						</tr>
						<tr>
							<td> shipping.address </td>
							<td> Object </td>
							<td> The object representation of the shipping address </td>
							<td> </td>
						</tr>
						<tr>
							<td> shipping.address.name </td>
							<td> Object </td>
							<td> An object representation of a person's name </td>
							<td> </td>
						</tr>
						<tr>
							<td> shipping.address.name.full </td>
							<td> String </td>
							<td> The full name of this person, including middle names, suffixes, etc. </td>
							<td> </td>
						</tr>
						<tr>
							<td> shipping.address.name.first </td>
							<td> String </td>
							<td> The family name (last name) of this person </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form  </td>
						</tr>
						<tr>
							<td> shipping.address.name.last </td>
							<td> String </td>
							<td> The given name (first name) of this person </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form </td>
						</tr>
						<tr>
							<td> shipping.address.full </td>
							<td> String </td>
							<td> The full address in not-well-formatted  </td>
							<td>  </td>
						</tr>
						<tr>
							<td> shipping.address.address1 </td>
							<td> String </td>
							<td> The first line of the address </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form </td>
						</tr>
						<tr>
							<td> shipping.address.address2 </td>
							<td> String </td>
							<td> The second line of the address </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form </td>
						</tr>
						<tr>
							<td> shipping.address.country_code </td>
							<td> String </td>
							<td> The country code </td>
							<td><a href="http://en.wikipedia.org/wiki/ISO_3166-1_alpha-2" target="_blank">ISO 3166-1 alpha-2</a> (exception: UK instead of GB) </td>
						</tr>
						<tr>
							<td> shipping.address.city </td>
							<td> String </td>
							<td> The city  </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form </td>
						</tr>
						<tr>
							<td> shipping.address.state </td>
							<td> String </td>
							<td> The state  </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form </td>
						</tr>
						<tr>
							<td> shipping.address.postal_code </td>
							<td> String </td>
							<td> The postal code </td>
							<td> It is provided only if a buyer updated his/her address and name as a normalized form </td>
						</tr>
						<tr>
							<td> shipping.address.phone_number </td>
							<td> String </td>
							<td> The buyer's phone number </td>
							<td> It is provided only if a buyer included his/her phone number with their shipping address </td>
						</tr>
						<tr>
							<td> cost </td>
							<td> Object </td>
							<td> Cost information for this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.currency_code </td>
							<td> String </td>
							<td> The currency code of the transaction </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a></td>
						</tr>
						<tr>
							<td> cost.subtotal </td>
							<td> Fixed Point Number </td>
							<td> The total price for the order exclusive of shipping and other costs <br/>(This must equal the sum of all the items)</td>
							<td></td>
						</tr>
						<tr>
							<td> cost.grand_total </td>
							<td> Fixed Point Number </td>
							<td> The total price for the order inclusive of tax, shipping and other costs</td>
							<td></td>
						</tr>
						<tr>
							<td> cost.salesTax_collected_by_BL </td>
							<td> Fixed Point Number </td>
							<td> Sales tax collected by BL, if that applies</td>
							<td></td>
						</tr>
						<tr>
							<td> cost.final_total </td>
							<td> Fixed Point Number </td>
							<td> Grand total - Sales tax collected by BL</td>
							<td></td>
						</tr>
						<tr>
							<td> cost.etc1 </td>
							<td> Fixed Point Number </td>
							<td> Extra charge for this order (tax, packing, etc.) </td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.etc2 </td>
							<td> Fixed Point Number </td>
							<td> Extra charge for this order (tax, packing, etc.) </td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.insurance </td>
							<td> Fixed Point Number </td>
							<td> Insurance cost </td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.shipping </td>
							<td> Fixed Point Number </td>
							<td> Shipping cost </td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.credit </td>
							<td> Fixed Point Number </td>
							<td> Credit applied to this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.coupon </td>
							<td> Fixed Point Number </td>
							<td> Amount of coupon discount</td>
							<td> </td>
						</tr>
						<tr>
							<td> cost.vat_rate </td>
							<td> Fixed Point Number </td>
							<td> VAT percentage applied to this order </td>
							<td> Upcoming Feature </td>
						</tr>
						<tr>
							<td> cost.vat_amount </td>
							<td> Fixed Point Number </td>
							<td> Total amount of VAT included in the grand_total price </td>
							<td> Upcoming Feature </td>
						</tr>
						<tr>
							<td> <del>cost.disp_currency_code</del> </td>
							<td> <del>String</del> </td>
							<td> <del>The display currency code of the user</del>  </td>
							<td> deprecated </td>
						</tr>
						<tr>
							<td> <del>cost.disp_subtotal</del> </td>
							<td> <del>Fixed Point Number</del> </td>
							<td> <del>The subtotal price in display currency of the user</del> </td>
							<td> deprecated </td>
						</tr>
						<tr>
							<td> <del>cost.disp_grand_total</del> </td>
							<td> <del>Fixed Point Number</del> </td>
							<td> <del>The grand total price in display currency of the user</del> </td>
							<td> deprecated </td>
						</tr>
						<tr>
							<td> disp_cost </td>
							<td> Object </td>
							<td> Cost information for this order in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.currency_code </td>
							<td> String </td>
							<td> The display currency code of the user </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a></td>
						</tr>
						<tr>
							<td> disp_cost.subtotal </td>
							<td> Fixed Point Number </td>
							<td> The subtotal price in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.grand_total </td>
							<td> Fixed Point Number </td>
							<td> The grand total price in DISPLAY currency </td>
							<td>  </td>
						</tr>
						<tr>
							<td> disp_cost.etc1 </td>
							<td> Fixed Point Number </td>
							<td> Extra charge for this order (tax, packing, etc.) in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.etc2 </td>
							<td> Fixed Point Number </td>
							<td> Extra charge for this order (tax, packing, etc.) in DISPLAY currency </td>
							<td></td>
						</tr>
						<tr>
							<td> disp_cost.insurance </td>
							<td> Fixed Point Number </td>
							<td> Insurance cost in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.shipping </td>
							<td> Fixed Point Number </td>
							<td> Shipping cost in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.credit </td>
							<td> Fixed Point Number </td>
							<td> Credit applied to this order in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.coupon </td>
							<td> Fixed Point Number </td>
							<td> Amount of coupon discount in DISPLAY currency </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_cost.vat_rate </td>
							<td> Fixed Point Number </td>
							<td> VAT percentage applied to this order </td>
							<td> Upcoming Feature </td>
						</tr>
						<tr>
							<td> disp_cost.vat_amount </td>
							<td> Fixed Point Number </td>
							<td> Total amount of VAT included in the grand_total price in DISPLAY currency </td>
							<td> Upcoming Feature </td>
						</tr>
					</tbody>
				</table>

				<h4>Example</h4>
				<Highlight className="json">{`{
    "order_id":3905404,
    "date_ordered":"2013-10-29T17:59:06.373Z",
    "date_status_changed":"2014-02-26T01:26:55.467Z",
    "seller_name":"covariance",
    "store_name":"skbrickshop",
    "buyer_name":"sklee",
    "buyer_email":"sklee@fakemail.com",
    "require_insurance":false,
    "status":"PENDING",
    "is_invoiced":true,
    "remarks":"my remarks",
    "total_count":1,
    "unique_count":1,
    "total_weight":"1.03",
    "buyer_order_count":2,
    "is_filed":false,
    "drive_thru_sent":true,
    "payment":{
        "method":"PayPal.com",
        "currency_code":"EUR",
        "date_paid":"2014-02-26T01:29:28.147Z",
        "status":"Sent" 
    },
    "shipping":{
        "method_id":17862,
        "method":"PostBox",
        "tracking_link":"12323132",
        "address":{
            "name":{
                "full":"Seulki Lee" 
            },
        "full":"fake address",
        "country_code":"KR" 
        }
    },
    "cost":{
        "currency_code":"EUR",
        "subtotal":"10.1210",
        "grand_total":"13.1210",
        "etc1":"0.0000",
        "etc2":"0.0000",
        "insurance":"0.0000",
        "shipping":"3.0000",
        "credit":"0.0000",
        "coupon":"0.0000",
        "vat_rate":"19.00",
        "vat_amount":"2.0949" 
    },
    "disp_cost":{
        "currency_code":"EUR",
        "subtotal":"10.1210",
        "grand_total":"13.1210",
        "etc1":"0.0000",
        "etc2":"0.0000",
        "insurance":"0.0000",
        "shipping":"3.0000",
        "credit":"0.0000",
        "coupon":"0.0000",
        "vat_rate":"19.00",
        "vat_amount":"2.0949" 
    }
}`}</Highlight>
				<h2>Order Item</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> inventory_id </td>
							<td> Integer </td>
							<td> The ID of the store inventory that includes the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item </td>
							<td> Object </td>
							<td> An object representation of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.no </td>
							<td> String</td>
							<td> Item's identification number in BL catalog </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.name </td>
							<td> String </td>
							<td> The name of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> item.type </td>
							<td> String </td>
							<td> The type of the item </td>
							<td> MINIFIG, PART, SET, BOOK, GEAR, CATALOG, INSTRUCTION, UNSORTED_LOT, ORIGINAL_BOX </td>
						</tr>
						<tr>
							<td> item.category_id </td>
							<td> Integer </td>
							<td> The main category of the item </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_id </td>
							<td> Integer </td>
							<td> The ID of the color of the item  </td>
							<td> </td>
						</tr>
						<tr>
							<td> color_name </td>
							<td> String </td>
							<td> Color name of the item </td>
							<td> Upcoming feature </td>
						</tr>
						<tr>
							<td> quantity </td>
							<td> Integer </td>
							<td> The number of items purchased in this order </td>
							<td> </td>
						</tr>
						<tr>
							<td> new_or_used </td>
							<td> String</td>
							<td> Indicates whether the item is new or used </td>
							<td> N: New, U: Used </td>
						</tr>
						<tr>
							<td> completeness </td>
							<td> String </td>
							<td> Indicates whether the set is complete or incomplete <br/>(This value is valid only for SET type) </td>
							<td> C: Complete, B: Incomplete, S: Sealed </td>
						</tr>
						<tr>
							<td> unit_price </td>
							<td> Fixed Point Number </td>
							<td> The original price of this item per sale unit </td>
							<td> </td>
						</tr>
						<tr>
							<td> unit_price_final </td>
							<td> Fixed Point Number </td>
							<td> The unit price of this item after applying tiered pricing policy </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_unit_price </td>
							<td> Fixed Point Number </td>
							<td> The original price of this item per sale unit in display currency of the user </td>
							<td> </td>
						</tr>
						<tr>
							<td> disp_unit_price_final </td>
							<td> Fixed Point Number </td>
							<td> The unit price of this item after applying tiered pricing policy in display currency of the user </td>
							<td> </td>
						</tr>
						<tr>
							<td> currency_code </td>
							<td> String </td>
							<td> The currency code of the price </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a></td>
						</tr>
						<tr>
							<td> disp_currency_code </td>
							<td> String </td>
							<td> The display currency code of the user  </td>
							<td> <a href="http://en.wikipedia.org/wiki/ISO_4217" target="_blank">ISO 4217</a></td>
						</tr>
						<tr>
							<td> remarks </td>
							<td> String </td>
							<td> User remarks of the order item </td>
							<td> </td>
						</tr>
						<tr>
							<td> description </td>
							<td> String </td>
							<td> User description of the order item </td>
							<td> </td>
						</tr>
						<tr>
							<td> weight </td>
							<td> Fixed Point Number </td>
							<td> The weight of the item that overrides the catalog weight </td>
							<td> Upcoming feature </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "inventory_id":50133258,
        "item": {
            "no":"7644-1",
            "name":"MX-81 Hypersonic Operations Aircraft",
            "type":"SET",
            "categoryID":34
        },
        "color_id":0,
        "quantity":1,
        "new_or_used":"N",
        "completeness":"S",
        "unit_price":"139.9900",
        "unit_price_final":"139.9900",
        "disp_unit_price":"139.9900",
        "disp_unit_price_final":"139.9900",
        "currency_code":"USD",
        "disp_currency_code":"USD",
        "description":"",
        "remarks":"" 
}`}</Highlight>
				<h2>Order Message</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> subject </td>
							<td> String </td>
							<td> The subject of the message </td>
							<td> </td>
						</tr>
						<tr>
							<td> body </td>
							<td> String </td>
							<td> The contents of the message </td>
							<td> </td>
						</tr>
						<tr>
							<td> from </td>
							<td> String </td>
							<td> The username of who sends the message </td>
							<td> </td>
						</tr>
						<tr>
							<td> to </td>
							<td> String </td>
							<td> The username of who receives the message  </td>
							<td> </td>
						</tr>
						<tr>
							<td> dateSent </td>
							<td> Timestamp </td>
							<td> The time the message was sent </td>
							<td> </td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "subject":"Regarding BrickLink Order #3986441",
    "body":"Hello...",
    "from":"covariance1",
    "to":"sklee",
    "dateSent":"2013-10-04T14:54:30.947Z" 
}`}</Highlight>
				<h2>Order Problem</h2>
				<h4>Resource</h4>
				<table>
					<tbody>
						<tr>
							<th>Property name </th>
							<th>Value </th>
							<th>Description </th>
							<th>Note </th>
						</tr>
						<tr>
							<td> type </td>
							<td> String </td>
							<td> The type of the problem </td>
							<td> FILE_NPB, REMOVE_NPB </td>
						</tr>
						<tr>
							<td> message </td>
							<td> String </td>
							<td> Your comment about the problem </td>
							<td> </td>
						</tr>
						<tr>
							<td> reason_id </td>
							<td> String </td>
							<td> The reason why you file the case </td>
							<td> <a href="?page=order-problem-reason">Available reasons</a></td>
						</tr>
					</tbody>
				</table>
				<h4>Example</h4>
				<Highlight className="json">{`{
    "type":"FILE_NPB",
    "message":"buyer is not responding for 10 days",
    "reason_id":"6",
}`}</Highlight>
			</section>
		);
	}
}